import { render, staticRenderFns } from "./InspectionTemplatePointDrawer.vue?vue&type=template&id=540b3b43&scoped=true&"
import script from "./InspectionTemplatePointDrawer.vue?vue&type=script&lang=js&"
export * from "./InspectionTemplatePointDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InspectionTemplatePointDrawer.vue?vue&type=style&index=0&id=540b3b43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b3b43",
  null
  
)

export default component.exports